import React, {createContext, useContext, useState, useEffect, useCallback, useMemo} from "react";

const AuthContext = createContext(null);

const STORAGE_KEY = "rd_auth";

export const AuthProvider = ({children}) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        setUser(parsed.user || null);
        setToken(parsed.token || null);
      }
    } catch (e) {
      // ignore
    }
  }, []);

  const persist = useCallback((nextUser, nextToken) => {
    setUser(nextUser);
    setToken(nextToken);
    if (nextUser && nextToken) {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({user: nextUser, token: nextToken})
      );
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  }, []);

  const login = useCallback((nextUser, nextToken) => {
    persist(nextUser, nextToken);
  }, [persist]);

  const logout = useCallback(() => {
    persist(null, null);
  }, [persist]);

  const value = useMemo(() => ({
    user,
    token,
    isAuthenticated: !!user,
    isAdmin: !!user && user.role === "admin",
    login,
    logout,
  }), [user, token, login, logout]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
